import { ListChecks } from "lucide-react"

import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"
import { useTranslations } from "next-intl"


export function DeliveryToolsRecommendation() {
  const tUi = useTranslations("Deliveries.DeliveriesDeliveryToolsRecommendation")

  return (
    <Alert className="border-violet-200 bg-violet-50/70">
      <ListChecks aria-hidden="true" className="h-4 w-4 text-violet-700" />
      <AlertTitle className="text-violet-950">
        <span key={tUi("recommendedOrderToolSetup")}>{tUi("recommendedOrderToolSetup")}</span></AlertTitle>
      <AlertDescription className="text-violet-900">
        <span key={tUi("forACompleteCRMAndDeliveryWorkflowEnable")}>{tUi("forACompleteCRMAndDeliveryWorkflowEnable")}</span></AlertDescription>
    </Alert>
  )
}
